import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=de4f5d56"
import script from "./ImageDropzone.vue?vue&type=script&lang=js"
export * from "./ImageDropzone.vue?vue&type=script&lang=js"
import style0 from "./ImageDropzone.vue?vue&type=style&index=0&id=de4f5d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports